export enum ButtonVariant {
    PRIMARY = '--primary',
    SECONDARY = '--secondary',
    INVISIBLE = '--invisible',
    DARK = '--dark',
    HIGH_PRIORITY = '--high-priority',
}
